const DEDUCTIBLE_PAYMENT_TYPES = new Set(["advance", "additional_payment"]);

export const manualPaymentFeeEntry = (payment = {}) => {
  if (!DEDUCTIBLE_PAYMENT_TYPES.has(payment.paymentType)) return null;
  const isAdvance = payment.paymentType === "advance";
  return {
    id: `${isAdvance ? "advance" : "additional-payment"}-${
      payment.id || payment.sourceRowNumber || payment.date
    }`,
    chargeType: isAdvance ? "Advances" : "Payments",
    manualChargeType: isAdvance ? "Advances" : "Additional Payment",
    date: payment.date,
    description:
      payment.description ||
      (isAdvance ? "Advance deduction" : "Additional payment"),
    amountCharged: isAdvance
      ? Number(payment.amountDeducted || payment.amountPaid || 0)
      : Math.abs(Number(payment.amountPaid || payment.amountDeducted || 0)),
  };
};

export const manualPaymentFeeEntries = (payments = []) =>
  payments.map(manualPaymentFeeEntry).filter(Boolean);
